/** Chave estável do período de pagamento de plantão (local × consulta). */

export const buildMonthPeriodKey = (year: number, month0to11: number): string => {
  const month = String(month0to11 + 1).padStart(2, '0')
  return `month:${year}-${month}`
}

export const buildCustomPeriodKey = (startIso: string, endIso: string): string =>
  `custom:${startIso}|${endIso}`

/** Converte valor datetime-local (`YYYY-MM-DDTHH:MM`) para ISO-8601. */
export const datetimeLocalToIso = (dtLocal: string): string => {
  const parsed = new Date(dtLocal)
  return Number.isNaN(parsed.getTime()) ? new Date().toISOString() : parsed.toISOString()
}
